export const SUPPORTED_LANGUAGES = [
    { id: 'ar', name: 'العربية', flag: 'SA', dir: 'rtl' },
    { id: 'de', name: 'Deutsch', flag: 'DE', dir: 'ltr' },
    { id: 'en', name: 'English', flag: 'US', dir: 'ltr' },
    { id: 'es', name: 'Español', flag: 'ES', dir: 'ltr' },
    { id: 'fr', name: 'Français', flag: 'FR', dir: 'ltr' },
    { id: 'he', name: 'עברית', flag: 'IL', dir: 'rtl' },
    { id: 'it', name: 'Italiano', flag: 'IT', dir: 'ltr' },
    { id: 'pt', tag: 'pt-BR', name: 'Português', flag: 'BR', dir: 'ltr' },
    { id: 'ru', name: 'Русский', flag: 'RU', dir: 'ltr' },
];
/** The language's BCP 47 tag, for `lang`/`hreflang` attributes and the kit's locales. */
export const languageTag = (lang) => lang.tag ?? lang.id;
